<template>
  <div class="pr-5">
    <HorizontalBarChart
      v-if="isHorizontal"
      :height="height"
      :chartData="chartData"
      :options="chartOptions"
    ></HorizontalBarChart>

    <ColumnChart
      v-if="!isHorizontal"
      :height="height"
      :chartData="chartData"
      :options="chartOptions"
    ></ColumnChart>
  </div>
</template>

<script>
import HorizontalBarChart from "@components/charts/HorizontalBarChart.vue";
import ColumnChart from "@components/charts/ColumnChart.vue";

export default {
  components: {
    ColumnChart,
    HorizontalBarChart
  },

  props: {
    data: { type: Array },
    dataType: { type: String, default: 'orders_by_users' },
    param: { type: String },
    height: { type: Number, default: 180 },
    barThickness: { type: Number },
    isHorizontal: { type: Boolean, default: false }
  },

  data() {
    return {
      chartOptions: {
        scales: {
          yAxes: [
            {
              stacked: false,
              ticks: {
                beginAtZero: false,
                min: 0,
                callback: (value) => {
                  return this.formatNumber(value);
                }
              },
            },
          ],
          xAxes: [
            {
              stacked: false,
              ticks: {
                beginAtZero: false,
                min: 0,
                callback: (value) => {
                  return this.formatNumber(value);
                }
              },
            },
          ],
        },
        legend: {
          display: false,
        },
        tooltips: {
          enabled: true,
          callbacks: {
            label: (tooltipItem) => {
              return this.formatNumber(tooltipItem.yLabel || tooltipItem.xLabel);
            }
          }
        },
        plugins: {
          datalabels: {
            display: true,
            formatter: (value) => {
              return this.formatNumber(value);
            }
          }
        },
        responsive: true,
        maintainAspectRatio: false,
      },
    };
  },

  computed: {
    chartData() {
      let graphData = {
        labels: [],
        datasets: [
          {
            barThickness: this.barThickness ? this.barThickness : 'flex',
            data: [],
            borderColor: ["red"],
            backgroundColor: [
              "#2dbd63",
              "#ffa764",
              "#36acf4",
              "#bcbab9",
              "#2dbd63",
              "#ffa764",
              "#36acf4",
              "#bcbab9",
              "#2dbd63",
              "#ffa764",
              "#36acf4",
              "#bcbab9",
              "#2dbd63",
              "#ffa764",
              "#36acf4",
              "#bcbab9",
              "#2dbd63",
              "#ffa764",
              "#36acf4",
              "#bcbab9",
            ],
            hoverBackgroundColor: [],
          },
        ],
      };

      if (this.dataType === 'orders_by_users') {
        for (let prop in this.data) {
          graphData.labels.push(this.data[prop]['user_name']);
          graphData.datasets[0].data.push(this.data[prop]['total']);
        }
      } else if (this.dataType === 'margin-profit-company-year') {
        for (let prop in this.data) {
          graphData.labels.push(this.data[prop]['name']);
          graphData.datasets[0].data.push(this.data[prop]['total']);
        }
      } else {
        for (let prop in this.data) {
          graphData.labels.push(this.data[prop]['name']);
          graphData.datasets[0].data.push(this.data[prop]['result'][this.param]);
        }
      }

      graphData.datasets[0].hoverBackgroundColor = graphData.datasets[0].backgroundColor;

      return graphData;
    },
  },

  methods: {
    formatNumber(value) {
      if (typeof value === "number" && value % 1 === 0) {
        return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, " ");
      }
      return value;
    }
  }
};
</script>

<style lang="scss">
.legend {
  position: absolute;
  right: 20px;
  top: 20px;
  cursor: help;

  &__tooltip {
    cursor: help;
    .tooltip-inner {
      max-width: 400px;
      text-align: left;
      padding: 15px;

      ul {
        margin: 0;
      }

      li:not(:last-of-type) {
        margin-bottom: 10px;
      }
    }
  }
}
</style>
